import { defineMessages, useIntl } from 'react-intl';

import { Attachments } from '@arpav/components/ArpavTheme/View';
import PropTypes from 'prop-types';

const messages = defineMessages({
  documenti: {
    id: 'event_documenti',
    defaultMessage: 'Documenti',
  },
});

const EventoDocumenti = ({ content }) => {
  const intl = useIntl();

  return (
    <Attachments
      content={content}
      folder_name={'documenti'}
      title={intl.formatMessage(messages.documenti)}
    />
  );
};

EventoDocumenti.propTypes = {
  content: PropTypes.object.isRequired,
};

export default EventoDocumenti;
